document.addEventListener("turbo:load", function() {
  onToggleMenu();
  onClickLink();
  onClickBackbutton();
  onClickOutside();
  calculateSubNavigationHeight();
});

$(window).on("resize", function () {
  // closeNavigation();
  calculateSubNavigationHeight();
});

function onToggleMenu() {
  $(".js-menubutton").on("click", function () {
    $(this).toggleClass("menubutton--active");
    $("html").toggleClass("html-menubutton--active");
    $(".js-level-1").toggleClass("level-1--active");

    $("body").toggleClass("noscroll");
  });
}

function onClickLink() {
  $(".js-link").on("click", function (event) {
    const $activeNavigationItem = $(this).parent();

    if ($activeNavigationItem.hasClass("js-has-subnavigation")) {
      event.preventDefault
        ? event.preventDefault()
        : (event.returnValue = false);

      const level = +$activeNavigationItem[0].dataset.level;

      $activeNavigationItem
        .find(`:is(a, button)[data-level="${level + 1}"]`)
        .attr("tabindex", 0);

      $(this).attr("aria-expanded", "true");
    }

    $activeNavigationItem
      .addClass("active")
      .siblings()
      .removeClass("active")
      .find(".active")
      .removeClass("active");

    $("body").addClass("noscroll");
  });
}

function onClickBackbutton() {
  $(".js-backbutton").on("click", function () {
    let $activeNavigationItem = $(this)[0].closest("li.active");
    $activeNavigationItem.classList.remove("active");
    removeOverflowContainer();

    // close navigation__level-2 & navigation__level-3 on desktop
    if ($("body").width() >= 768) {
      $(".js-level-1").find("li").removeClass("active");
    }
    $("body").removeClass("noscroll");
    $(this).parent("[aria-expanded=true]").attr("aria-expanded", "false");
  });
}

function onClickOutside() {
  $("body").click(function (event) {
    const $navigation = $(".js-navigation").get(0);
    if (
      $navigation &&
      $navigation !== event.target &&
      !$.contains($navigation, event.target)
    ) {
      closeNavigation();
    }
  });
}

function closeNavigation() {
  $(".js-menubutton").removeClass("menubutton--active");
  $("html").removeClass("html-menubutton--active");
  $(".js-level-1")
    .removeClass("level-1--active")
    .find(".active")
    .removeClass("active");
  removeOverflowContainer();

  $("body").removeClass("noscroll");
}

function calculateSubNavigationHeight() {
  $(".level-2").css("min-height", "auto");

  if ($("body").width() < 768) {
    $(".level-3").css("min-height", "auto");
    // for overflow scroll on mobile
    $(".level-2").addClass("overflow-container");
  } else {
    $(".level-3").css("min-height", "100%");

    $(".level-2").each(function () {
      const $level3 = $(this).find(".level-3");

      let minHeight = 0;

      $level3.each(function () {
        if ($(this).outerHeight() > minHeight) {
          minHeight = $(this).outerHeight();
        }
      });

      $(this).css("min-height", minHeight);
    });
  }
}

function removeOverflowContainer() {
  $(".overflow-container").removeClass("overflow-container");
}
